<template>
<div class="lpanel">
      <div class="sidebar-toggle"><i class="fa fa-bars"></i></div>
      <div id="sidebar" class="sbar">
      
      
        <!-- Sidebar user panel -->
        <div class="user-panel">
            <div class="pull-left" v-if="!results.session.is_login">
                <img src="img/logo.png" class="logo-img"  alt="Girish Jewellers">
            </div>

            <div class="pull-left image" v-if="results.session.is_login">
                <img src="img/avatar.png" class="img-circle" alt="User Image">
            </div>
            <div class="pull-left info" v-if="results.session.is_login">
                <p>Hello, {{Session.first_name}} {{Session.last_name}}</p>
                <a href="javascript:void(0);" v-on:click="Logout"><i class="fa fa-sign-out text-success"></i> Logout</a>
            </div>
        </div>
        <!-- search form -->
        <div class="sidebar-form">
        <div class="input-group col-xs-12 alig-center">
                    <div style="margin-top:3px;">
          <a target="_blank" class="sbtnf sbtnf-squere sbtnf-icon-white sbtnf-icon-bg-black icon-instagram color" style="color:#fff" href="https://instagram.com/girish_jewellers_">instagram</a>
          <a class="sbtnf sbtnf-squere sbtnf-icon-white sbtnf-icon-bg-black icon-facebook color" style="color:#fff" href="#">Facebook</a>
          <a class="sbtnf sbtnf-squere sbtnf-icon-white sbtnf-icon-bg-black icon-twitter color" style="color:#fff" href="#">twitter</a>
          <a class="sbtnf sbtnf-squere sbtnf-icon-white sbtnf-icon-bg-black icon-gplus color" style="color:#fff" href="#">Gplus</a>
          <a class="sbtnf sbtnf-squere sbtnf-icon-white sbtnf-icon-bg-black icon-youtube color" style="color:#fff" href="#">Youtube</a>
        </div>
        </div>
        </div>
                <!-- /.search form -->
                <!-- sidebar menu: : style can be found in sidebar.less -->
                
        <ul class="sidebar-menu">
            <li class="active">
                <router-link to="/" onclick="hideSbar();">
                    <i class="fa fa-dashboard"></i> <span>Home</span>
                </router-link>
            </li>
            <li>
                <router-link to="/about">
                    <i class="fa fa-caret-right"></i> <span>About Us</span>
                </router-link>
            </li>
            <li>
                <router-link to="/contact" >
                    <i class="fa fa-caret-right"></i> <span>Contact Us</span>
                </router-link>
            </li>
            <li class="treeview ">
                <a href="javascript:void(0);">
                    <i class="fa  fa-caret-right"></i> <span>Catagories</span>
                    <i class="fa fa-angle-left pull-right"></i>
                </a>
                <ul class="treeview-menu">
                    <li v-for="(result) in AllCategories" :key="result.id">
                        <router-link style="margin-left: 10px;" :to="'/' + result.page_name" onclick="hideSbar();">
                            <i class="fa fa-angle-double-right"></i>
                            {{result.title}}
                        </router-link>
                    </li>
                </ul>
            </li>
            <li class="treeview " v-if="!results.session.is_login">
                <a href="javascript:void(0);">
                    <i class="fa  fa-caret-right"></i> <span>Account</span>
                    <i class="fa fa-angle-left pull-right"></i>
                </a>

                <ul class="treeview-menu">
                    <li><router-link to="/login" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> Login</router-link></li>
                    <li><router-link to="/create-account" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> Create Account</router-link></li>
                    <li><router-link to="/forgot-password" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> Forgot Password?</router-link></li>
                </ul>
            </li>
            <li class="treeview" v-if="results.session.is_login">
                <a href="javascript:void(0);">
                    <i class="fa  fa-caret-right"></i> <span>Account</span>
                    <i class="fa fa-angle-left pull-right"></i>
                </a>

                <ul class="treeview-menu">
                
                    <li><router-link to="/account" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> My Account</router-link></li>
                    <li><router-link to="/order-history" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> Order History</router-link></li>
                    <li><router-link to="/update-profile" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> Update Profile</router-link></li>
                    <li><router-link to="/change-password" style="margin-left: 10px;"><i class="fa fa-angle-double-right"></i> Change Password</router-link></li>
                    

                </ul>
            </li>
            <li v-if="isMobile()">
                <a href="javascript:navigator.app.exitApp();" >
                    <i class="fa fa-times"></i> <span>Exit</span>
                </a>
            </li>
        </ul>                    
                                        
                          
      
      <div style='position:relative;margin-top:-40px;margin-left:100%;height:100%;width:50%;z-index:1012' id="sbar-out-area"></div>
      
      </div>
      </div>
</template>      
<script>
//import $ from 'jquery'
import {mapGetters, mapActions} from "vuex";
import Common from '@/common.js'
export default {
  name: 'LeftPanel',
  props: {
    msg: String
  },data: function(){
    return {
       results: {'categories':{},'session':{}}
     }
  },
   computed:mapGetters(["Session","AllCategories"]),
     watch:{
     AllCategories(newValue) { this.get_response(newValue)  },
     Session(newValue) { this.results.session =  newValue  },
   }
  ,methods:{
      ...mapActions(["getSession","getCategories","logoutSession"]),
            isMobile:function(){
   return Common.isMobile();
},
    Logout:function()
    {
            this.logoutSession();
            this.$router.push("/login");
    },
    get_response:function(response)
    {  
        //var rdata = JSON.parse(response);
        this.results.categories = response;
    }
  }
  ,mounted: function() {
      this.getSession();
      this.getCategories();
      //Common.callServerFunction("Items/ItemController::GetCategory",this.get_response,{},"Item");
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>